<template>
	<div
		class="fixed z-7 width-full height-full-dynamic-viewport d-flex top-0 left-0 justify-center align-center"
		:class="interactableBackground ? '' : 'bg-transparent-l-dark'"
		@click="handleBackdropClick"
		:style="{ pointerEvents: interactableBackground ? 'none' : 'auto' }"
	>
		<DialogContainer
			:size="size"
			:is-simple="isSimple"
			:is-full-size="isFullSize"
			:is-bottom-sheet="isBottomSheet"
			:empty-dialog="emptyDialog"
		>
			<template #header>
				<slot name="header" />
			</template>
			<slot />
			<template #actions>
				<slot name="actions" />
			</template>
		</DialogContainer>
	</div>
</template>

<script setup lang="ts">
	import DialogContainer from './DialogContainer.vue'
	import { DialogSize } from './dialogTypes'

	interface Props {
		size?: DialogSize
		isSimple?: boolean
		isFullSize?: boolean
		isBottomSheet?: boolean
		interactableBackground?: boolean
		closeOnBackdropClick?: boolean
		emptyDialog?: boolean
	}

	const props = defineProps<Props>()

	const emit = defineEmits(['cancel'])

	const handleBackdropClick = () => {
		if (props.closeOnBackdropClick) emit('cancel')
	}
</script>

<style scoped></style>
